<template>
  <t-dropdown toggle-on-hover variant="rich-input">
    <template #trigger="{ isShown }">
      <base-button variant="rich-input-dropdown"
                           class="flex items-center"
      >
        <div class="relative flex items-center justify-center"
             :size="selectedOption.iconSize"
        >
          <component :is="selectedOption.icon" class="h-5 w-5"/>
          <vs-icon icon="arrow_drop_down"
                   class="dropdown-arrow transform transition-transform duration-500 relative"
                   size="1.1rem"
                   :class="{ 'rotate-180': isShown }"/>
        </div>
      </base-button>
    </template>

    <template>
      <base-tooltip-button v-for="option in options"
                           variant="rich-input"
                           :key="option.value"
                           class="flex items-center"
                           :tooltip-text="option.tooltip"
                           @click="applyFormat(option)"
      >
        <div class="flex items-center justify-center">
          <component :is="option.icon" class="h-6 w-6"/>
        </div>
      </base-tooltip-button>
    </template>
  </t-dropdown>
</template>

<script>
import BaseButton from '@/components/base-components/BaseButton.vue'
import BaseTooltipButton from '@/components/base-components/BaseTooltipButton.vue'
import AlignCenterIcon from '@/assets/images/icons/AlignCenterIcon.vue'
import AlignRightIcon from '@/assets/images/icons/AlignRightIcon.vue'
import AlignLeftIcon from '@/assets/images/icons/AlignLeftIcon.vue'
import OrderIcon from '@/assets/images/icons/OrderIcon.vue'
import BulletsIcon from '@/assets/images/icons/BulletsIcon.vue'
import AlignJustifyIcon from '@/assets/images/icons/AlignJustifyIcon.vue'

export default {
  name: 'RichInputToolbarDropdown',

  components: {
    BaseTooltipButton,
    BaseButton,
    BulletsIcon,
    OrderIcon,
    AlignLeftIcon,
    AlignRightIcon,
    AlignCenterIcon,
    AlignJustifyIcon
  },

  props: {
    options: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      selectedOption: null
    }
  },

  methods: {
    applyFormat(option) {
      this.$emit('apply-format', option.value)
      this.selectedOption = option
    }
  },

  created() {
    this.selectedOption = this.options[0]
  }
}
</script>
